import { PropsWithChildren } from 'react';

import { Button, ButtonProps, SxProps, Theme, styled } from '@mui/material';

export const StyledLinkBtn = styled(Button)`
  color: inherit;
  padding: 0;
  &:hover {
    background-color: transparent !important;
  }
  &:focus,
  &:active {
    border: none;
    outline: none;
  }
`;
interface InkLinkButtonPropType {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  sx?: SxProps<Theme>;
  buttonProps?: ButtonProps & { 'data-cy'?: string };
}
const InkLinkButton = ({
  onClick,
  sx,
  children,
  buttonProps,
}: PropsWithChildren<InkLinkButtonPropType>) => {
  return (
    <StyledLinkBtn onClick={onClick} sx={sx} {...buttonProps}>
      {children}
    </StyledLinkBtn>
  );
};
export default InkLinkButton;
